var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff5300;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Chainalysis_Mark_RGB_Orange") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,0c1.12,0,2.39.14,2.39.14a28.31,28.31,0,0,0-6.48,15.92A33.76,33.76,0,0,0,18.05,44.65c-6.47.7-13.79,3.66-18,7.89C-.95,23.52,21.29,0,50,0ZM57.2,87.18a27,27,0,0,1-4,.29,49.17,49.17,0,0,1-6.9-.57,51.83,51.83,0,0,1-7,12A50,50,0,0,1,1.72,62.82c4.51-5.35,14.93-8.45,21.4-8.45,13.8,0,21.12,7.32,23.66,18.73-8.31-2.25-13.24-6.9-16.48-13.8a16.68,16.68,0,0,0-5.91-1,16.83,16.83,0,0,0-5.35.85C22.7,73.1,36.22,83.52,52.69,83.52c15.21,0,21.68-7.74,21.68-7.74V63.94s-7.46,7.75-16.75,9.3A33.74,33.74,0,0,0,28.9,44.65C31.29,32.82,40.3,26.2,52.55,26.2s22.11,8.87,22.11,8.87V23.38s-6.34-5.92-17.6-7.18C57.34,11,60.72,4.51,64.38,2.11,79.72,6.9,94.51,19.86,98.73,38.73c0,0-6.76,6.76-19.43,6.76-10.42,0-17-5.21-20.7-14.36a17.28,17.28,0,0,0-6.05-1,15.4,15.4,0,0,0-5.63,1c4.08,14.65,17,24.5,31.4,24.5,14.08,0,21.68-6.47,21.68-6.47C100,78.45,77.61,99.44,51,100,54.1,97,56.49,90.42,57.2,87.18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d6c6a883da42228cf44f5e3c5a067f5a.svg";
export { ForwardRef as ReactComponent };